var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-text-field",
    _vm._b(
      {
        attrs: {
          "append-icon": _vm.isTextoVisible ? "visibility_off" : "visibility",
          type: _vm.isTextoVisible ? "text" : "password",
          value: _vm.value,
          "data-testid": _vm.testId
        },
        on: {
          input: _vm.handleChange,
          "click:append": _vm.handleVisibilityClick
        }
      },
      "v-text-field",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }